import React, { useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { TextField } from "@material-ui/core";

import { Model } from "../../types/models";
import * as Styled from "../Modal.styles";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  }),
);

interface ModelModalProps {
    open: boolean
    label: string
    model: Model
    handleApply: (model: Model) => void
    handleClose: () => void
}

const ModelModal = (props: ModelModalProps): JSX.Element => {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [model, setModel] = useState<Model>(props.model);

  const handleFieldChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => { 
    setModel({...model, [field]: e.target.value}); 
  };

  const handleApply = () => {
    props.handleApply(model);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <h2>{props.label}</h2>
      <Styled.ModelModalData>
        <TextField 
          label="Mark" 
          value={model?.mark?.markName}
          onChange={handleFieldChange("markName")}>
        </TextField>
        <TextField 
          label="Model" 
          value={model?.modelName}
          onChange={handleFieldChange("modelName")}>
        </TextField>
        <TextField 
          label="Picture URL" 
          value={model?.modelImageLink}
          onChange={handleFieldChange("modelImageLink")}>
        </TextField>
      </Styled.ModelModalData>
      <Styled.ModelModalButtons>
        <Styled.AddButton
          variant="contained"
          color="primary"
          onClick={handleApply}>
            Apply
        </Styled.AddButton>
        <Styled.CancelButton
          variant="contained"
          color="primary"
          onClick={() => props.handleClose()}>
            Cancel
        </Styled.CancelButton>
      </Styled.ModelModalButtons>
    </div>
  );

  return (
    <div>
      <Modal
        open={props.open}
        onClose={() => props.handleClose()}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
};

export { ModelModal };